import _ from 'lodash';
import customFilterColumnsExtend from '../../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../../admin_entities/active_storage/blob_detail.js';
import { shareColumnsExtend } from '../share';
const filterColumns = {
  filename_cont: {
    model_name: 'ActiveStorage::Blob',
    column_type: 'string',
    column_name: 'filename',
  },
  content_type_cont: {
    model_name: 'ActiveStorage::Blob',
    column_type: 'string',
    column_name: 'contentType',
  },
  tags_name_in: {
    column_type: 'has_many',
    model_name: 'ActiveStorage::Blob',
    extra: {
      model_name: 'ActsAsTaggableOn::Tag',
      value_column: 'name',
    },
    column_name: 'name',
  },
}
export const formColumnsConfig = {
 'self': {}
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('ActiveStorage::Blob', columns), filterColumnsExtend)
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('ActiveStorage::Blob', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
